import styled from "styled-components";
// import theme from "styled/theme";

export const AvatarCroperDiv = styled.div`
  // & .ant-upload.ant-upload-select-picture-card {
  //   height: 140px;
  //   max-width: 640px;
  //   width: 100%;
  //   & .label-upload {
  //     font-size: ${(props) => props.theme.font.size};
  //     & > p:first-of-type {
  //       color: ${(props) => props.theme.colors.text};
  //       & > span {
  //         color: ${(props) => props.theme.colors.primary};
  //       }
  //     }
  //     & > p:last-child {
  //       color: ${(props) => props.theme.colors.textMuted};
  //     }
  //   }
  // }
  // & .ant-upload-list-picture-card-container {
  //   height: 140px;
  //   max-width: 640px;
  //   width: 100%;
  // }
  // & .ant-upload-list-item-info:before {
  //   left: 0;
  // }
`;

export const ImageExplanation = styled.div`
  background-color: #f2f2f2;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  gap: 8px;

  width: 100%;
`;

export const ImageExplanationTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
`;

export const ImageExplanationList = styled.ul`
  margin: 0;
  padding: 0;
  list-style-position: inside;
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;
